import React, {useContext, useEffect, useState } from 'react';
import {SystemManager_API} from "../SystemManager.API";
import {useParams} from "react-router-dom";
import {AuthContext} from "../../../context/AuthContext";
import Page from "../../../components/Pages/Page";
import BreadCrumbsItems from "../../../components/Pages/BreadCrumbsItems/BreadCrumbsItems";
import { useAPI } from '../../../hooks/useAPI'
import ApiSearchInput from '../../../components/Organisms/APISearchInput'
import NumberFormat from 'react-number-format';
import moment from "moment";


function addPaymentPage() {
    const {addPayment,getPaymentsOfOrg} = SystemManager_API.counterAgents.verificationCenter
    const {verCenterId,verCenterName} = useParams()
    const {REACT_APP_URL_PREFIX} = process.env
    const {token} = useContext(AuthContext)
	const { APIRequest } = useAPI()
	const [payments, setPayments] = useState([]);
	const [companyId, setCompanyId] = useState(0);
	const [companyName, setCompanyName] = useState('');
	const [total, setTotal] = useState(0);
	const [comment, setComment] = useState('');
	const [balance, setBalance] = useState('');

	/*
	useEffect(async () => {
		await APIRequest(getVerCenterPrices(token.userId,verCenterId))
			.then(response => {
			  if (response.body) {
				  setTitle(response.body?.title);
				  setPrices(response.body?.prices);
			  }
			})
	}, []); // Pass empty array to only run once on mount.
	*/
	
	const breadCrumbsItems = [
        {title: 'Контрагенты'},
        {title: 'Платежи', actual: true},
    ]
	
	const refreshPaymentsOfOrg = async(companyId) => {
		await APIRequest(getPaymentsOfOrg(token.userId, companyId))
			.then(response => {
			  if (response.body) {
				  console.log(response.body?.data)
				  setPayments(response.body?.data)
				  setBalance(response.body?.balance)
			  }
			})
		
		
		setPayments
	}
	const addPaymentNow = async()=>{
		await APIRequest(addPayment(token.userId), {companyId: companyId, total: total,comment:comment})
			.then(response => {
			  if (response.body) {
				  alert(response.body?.message);
				  setComment('')
				  setTotal(0)
				  refreshPaymentsOfOrg(companyId)
			  }
			})
	}

    return (
        <>
            <Page mobile={true}>
                <BreadCrumbsItems style={{left: '100px'}} routes={breadCrumbsItems}/>
				<div style={{paddingTop: 100, paddingLeft:30,paddingRight:30,paddingBottom:30}}>
					<ApiSearchInput
						important
						hideIcon
						title='Удостоверяющий центр'
						chooseHandler={selectedOrg => {
							setCompanyId(selectedOrg)
							refreshPaymentsOfOrg(selectedOrg)
						}}
						orgType='verificationCenter'
						initialValue={companyName}
						name='company_name'/>
					<div className="live-Search"><div className="form__option ">
						<label htmlFor="total">Сумма <span>*</span></label>
						<NumberFormat
							id="total" className="form-input live-Search__input" 
							value={total} onChange={(event)=>{setTotal(event.target.value)}}
						/>
					</div></div>
					<div className="live-Search"><div className="form__option ">
						<label htmlFor="comment">Комментарий <span>*</span></label>
						<input
							id="comment" className="form-input live-Search__input" 
							value={comment} onChange={(event)=>{setComment(event.target.value)}}
						/>
					</div></div>
				
					<button onClick={()=>{addPaymentNow()}}  style={{padding: 7}}>Добавить сумму</button>
					{balance? <div><br/>
						БАЛАНС: {balance}
						<br/><br/>
					</div> : undefined }
					{payments && payments.length > 0 ?
						<table >
						 <tr>
						  <td>Дата</td>
						  <td>Сумма</td>
						  <td>Комментарий</td>
						 </tr>
						{payments.map(function(d, idx){
							 return (<tr key={idx}>
								<td>{moment(d.payed_date).format("YYYY-MM-DD HH:mm") }</td>
								<td style={{paddingLeft: 20,paddingRight: 20}}>{d.price}</td>
								<td>{d.pay_comment}</td>
							 </tr>)
						})}
						</table>
					: undefined}
				</div>
            </Page>
        </>
    );
}

export default addPaymentPage;


